<h2>AAFT</h2>
Onze wolanalyses worden uitgevoerd door
<a href="https://www.https://www.aaft.com.au/" target="_blank">
    <img src="assets/images/pages/aaft.jpg" alt="AAFT logo" />
</a>
<h2>AlpacaEase</h2>
Wij gebruiken AlpacaEase herdmanagement software
<a href="https://www.alpacaease.com/" target="_blank">
    <img src="assets/images/pages/alpaca_ease.jpg" alt="AlpacaEase" />
</a>

